import { inject } from '@angular/core';
import {ClinicInfoService} from "../../core/services/clinic.info.service";
import {ResConsumptionService} from "./components/res-consumption-component/res.consumption.service";
import {FeatMgmtService} from "./components/feat-mgmt/feat-mgmt.service";
import {CartService} from "../../shared/components/cart/cart.service";
import {AppResourceService} from "./components/feat-mgmt/app-resource.service";
import {PersonInvoiceDataService} from "./components/smm-invoice/billing-information/smm.personbillinginfo.service";
import {CompanyInvoiceDataService} from "./components/smm-invoice/billing-information/smm.companybillinginfo.service";
import {OrderHistoryService} from "./components/smm-invoice/order-history/order.history.service";

export const clinicInfoResolver = () => {
    const _clinicSettingsService = inject(ClinicInfoService);
    const _resConsumptionService = inject(ResConsumptionService);
    _clinicSettingsService.getClinicInfo(true);
    _resConsumptionService.getDataFromBE();
};

export const featMgmtResolver = () => {
    const _featMgmtService = inject(FeatMgmtService);
    const _appResourceService = inject(AppResourceService);
    _featMgmtService.getModuleInfoFromBE();
    _appResourceService.getResourceInfoFromBE();
};

export const invoiceInfoResolver = () => {
    const _personInvoiceDataService = inject(PersonInvoiceDataService);
    const _companyInvoiceDataService = inject(CompanyInvoiceDataService);
    _personInvoiceDataService.getDataFromBE();
    _companyInvoiceDataService.getDataFromBE();
};

export const cartResolver = () => {
    const _cartService = inject(CartService)
    _cartService.refreshCart();
};

export const orderHistoryResolver = () => {
    const _orderHistoryService = inject(OrderHistoryService);
    _orderHistoryService.getOrderHistoryFromBE();
};
